import React from 'react';
import { IField } from '../../../domain/form.interfaces';
import { EInput } from '../../../domain/input.interface';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CheckboxField.component.scss';

export function CheckboxFieldComponent(
  { input, label, trigger, info, meta: { touched, error } }: IField,
  props: any,
) {
  return (
    <span className='field-container'>
      <label htmlFor={props.name} className='checkbox'>
        <input
          {...input}
          type={EInput.CHECKBOX}
          className={
            touched && error ? 'field-error' : touched ? 'field-success' : ''
          }
          name={props.name}
          checked={input.value}
        />
        <span className='checkmark'></span>
        <span className='label'>{label}</span>
        {!!info && (
          <a
            href={info.link}
            aria-label={info.name}
            target='_blank'
            rel='noopener noreferrer'
          >
            <FontAwesomeIcon icon='info-circle' />
          </a>
        )}
        <div className='message-container'>
          {(touched || trigger) && error && (
            <span className='field-error-message'>
              <FormattedMessage id={error.id} values={{ value: error.value }} />
            </span>
          )}
        </div>
      </label>
    </span>
  );
}
